import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { fr } from 'date-fns/locale'
import { useTranslation } from 'next-i18next'
import { Calendar } from '~/components/ui/calendar'
import { cn } from '~/lib/utils'

const locales = {
	fr,
}

export const DayPicker = ({
	className,
	value,
	onChange,
}: {
	value?: string
	onChange: (value: string) => void
	className?: string
}) => {
	const { i18n } = useTranslation()

	return (
		<Calendar
			locale={locales[(i18n.language as 'fr') || 'fr']}
			className={cn('mx-auto', className)}
			mode='single'
			selected={value ? dateTimeUtils(value).toDate() : undefined}
			fromDate={dateTimeUtils().toDate()}
			toDate={dateTimeUtils().add(1, 'year').toDate()}
			onSelect={(value) => {
				if (value) {
					onChange(dateTimeUtils(value).format('YYYY-MM-DD'))
				}
			}}
		/>
	)
}
